module.exports = __webpack_public_path__ + "img/20190822135128272.006f78c8.png";